export default "__VITE_ASSET__BcqBQ00L__"